import { styled } from 'linaria/react';
import React, { useState } from 'react';
import { Query } from 'react-apollo';
import StoreDetail from '../Store/StoreDetail';
import { theme } from '../Theme';
import storesQuery from './StoresQuery.gql';

const ChooseStore = styled('div')`
  .select {
    background-color: #f8f8f8;
    border: 1px solid #eaeaea;
    border-radius: 3px;
    display: block;

    font-size: 15px;
    font-weight: 300;
    height: 40px;
    outline: none;
    padding: 0.5rem;
    transition: all ease 0.3s;
    width: 100%;
  }
  ${theme.below.lg} {
    margin: 0 1rem;
  }
  ${theme.below.sm} {
    margin: 0 0.5rem;
  }
`;

const SpecificStore = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  ${theme.below.md} {
    justify-content: center;
  }
`;

const Stores = () => {
  const [currentCity, setCity] = useState(null);

  return (
    <Query query={storesQuery}>
      {({ data, loading }) => {
        if (loading) return <div>Loading…</div>;

        let cities = data.stores.filter(cities => cities.city === currentCity);

        let stores = [];
        data.stores.forEach(store => {
          if (stores.indexOf(store.city) === -1) {
            stores.push(store.city);
          }
        });
        stores.sort();
        return (
          <>
            <ChooseStore>
              <select
                className="select"
                onChange={self => {
                  setCity(self.target.value);
                }}
              >
                <option>Välj ort</option>
                {stores.map(store => (
                  <option value={store} key={store}>
                    {store}
                  </option>
                ))}
              </select>
              {currentCity === 'Välj ort' ? (
                <span>&nbsp;</span>
              ) : (
                <SpecificStore>
                  {cities.map((store, i) => (
                    <div key={i}>
                      <StoreDetail store={store} />
                    </div>
                  ))}
                </SpecificStore>
              )}
            </ChooseStore>
          </>
        );
      }}
    </Query>
  );
};

export default Stores;
